<script>
export default {
  name: 'MenuItem',
  functional: true,
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  },
  render(h, context) {
    const { icon, title } = context.props
    const vnodes = []

    vnodes.push(<svg-icon icon-class={icon} />)

    if (title) {
      vnodes.push(<span slot="title">{title}</span>)
    }
    return vnodes
  }
}
</script>
<style lang="scss" scoped>
.menu-icon {
  display: inline;
}
</style>



// WEBPACK FOOTER //
// src/layout/components/Sidebar/Item.vue